import React, { FC } from 'react';

import * as ST from './styled';

export interface StageTitleProps {
    stageTitle: string,
    stageSubTitle?: string,
    stageNumber?: number,
    currentNumber: number,
    isSubscriptionsNotSelected?: boolean | null,
}

export const StageTitle: FC<StageTitleProps> = ({ stageTitle, stageSubTitle, stageNumber, currentNumber, isSubscriptionsNotSelected }) => {
    const isUnactive = () => {
        if (isSubscriptionsNotSelected) {
          return isSubscriptionsNotSelected;
        }
        return stageNumber ? currentNumber < stageNumber : false;
    };

    return (
        <ST.StageTitleWrapper>
            <ST.StageTitle isUnactive={isUnactive()}>
                {stageTitle}
                {stageSubTitle && <>
                    &nbsp;
                    <ST.StageSubTitle>
                        {stageSubTitle}
                    </ST.StageSubTitle>
                </>}
            </ST.StageTitle>
        </ST.StageTitleWrapper>
    );
};
